/**
 * 根据url下载文件
 * @param {*} url 
 * @param {*} fileName 
 */
export function downloadFile(url, fileName) {
  // 下载文件
  if (!url) return;
  var x = new XMLHttpRequest();
  x.open("GET", url, true);
  x.responseType = "blob";
  x.onload = function (e) {
    var url = window.URL.createObjectURL(x.response);
    var a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
  };
  x.send();
}
;

/**
 * 检查手机号格式
 * @param {*} tel 
 * @returns 
 */
export function isPhoneNumber(tel) {
  return /^1[0-9]{10}$/.test(tel);
}